import { useMemo } from 'react';
import { domainConfig } from '../config/domain.config';
import { getEmbeddingInfo, type EmbeddingInfo } from '../utils/embedding';

export type DomainInfo = EmbeddingInfo;

export interface UseDomainTrackingResult {
  info: DomainInfo;
  isEmbeddingBlocked: boolean;
  isEmbeddedOnDistributorSite: boolean;
  allowedDomains: string[];
}

export function useDomainTracking(): UseDomainTrackingResult {
  const info = getEmbeddingInfo();

  return useMemo(() => {
    const isEmbeddingBlocked =
      domainConfig.enableDomainRestrictions && info.isEmbedded && !info.allowedDomain;
    const isOurWebsite = info.parentDomain === 'www.hi-levelmezzanines.co.uk';
    const isEmbeddedOnDistributorSite = info.isEmbedded && !isOurWebsite;
    return {
      info,
      isEmbeddingBlocked,
      isEmbeddedOnDistributorSite,
      allowedDomains: [...domainConfig.allowedDomains],
    };
  }, [info]);
}
